var main = {
  jsToggles: function() {
      var linkToggle = document.querySelectorAll('.js-toggle');

      for(i = 0; i < linkToggle.length; i++) {
      linkToggle[i].addEventListener('click', function(event) {
      event.preventDefault();

      var container = document.getElementById(this.dataset.container);
      
      if (!container.classList.contains('active')) {
          this.classList.add('is-open');
          container.classList.add('active');
          container.style.height = 'auto';
      
          var height = container.clientHeight + 'px';
      
          container.style.height = '0px';
      
          var parentContainer = container.closest('.sub-parent')
      
      
          setTimeout(function () {
          container.style.height = height;
              if (parentContainer != undefined && parentContainer.clientHeight > 0) {
              setTimeout( function() {
                  parentContainer.style.height = 'auto';
                  var parentHeight = parentContainer.clientHeight + 'px';
          
                  parentContainer.style.height = '0px';
      
                  parentContainer.style.height = parentHeight;
              }, 100)
              }
          }, 0);
          
      } else {
          this.classList.remove('is-open');
          
          container.style.height = '0px';
      
          if (container.classList.contains('no-trans')) {
          container.classList.remove('active');
          } else {
          container.addEventListener('transitionend', function () {
              container.classList.remove('active');
          }, {
              once: true
          });
          }
          
          setTimeout(function () {
          var parentContainer = container.closest('.sub-parent')
          var innerSub = container.closest('.inner-sub')
      
          if (innerSub != null) {
              parentContainer.style.height = innerSub.clientHeight + 'px';
          }
          }, 100);
      }
      
      });
      
      }
  },
  megamenu: function() {
    const links = document.querySelectorAll('.mega-menu__link--level-2');
    const panels = document.querySelectorAll('.mega-menu-last-level');

    function setActiveMenu(id) {
      links.forEach(m => m.classList.remove('mega-menu__link--active'));
      panels.forEach(last => last.classList.remove('active'));

      document.querySelector(`.mega-menu__link--level-2#${id}`)?.classList.add('mega-menu__link--active');
      document.querySelector(`.mega-menu-last-level[data-id="${id}"]`)?.classList.add('active');
    }

    // handle click + hover
    links.forEach(link => {
      link.addEventListener('click', function(evt) {
        setActiveMenu(this.id);
      });

      link.addEventListener('mouseenter', function() {
        setActiveMenu(this.id);
      });
    });

    // handle default active on load
    const defaultActive = document.querySelector('.mega-menu__link--level-2.mega-menu__link--active');
    if (defaultActive) {
      setActiveMenu(defaultActive.id);
    } else {
      if (document.querySelector('.mega-menu__link--level-2:first-child')) {
        setActiveMenu(document.querySelector('.mega-menu__link--level-2:first-child')?.id);
      }
    }
  },
  preventHashLinks: function() {
    document.querySelectorAll('a[href="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        e.preventDefault();
      });
    });
  },
  discountTextWidth: function() {
    function applyWidth() {
      document.querySelectorAll('.has-discount-text').forEach(el => {
        const price = el.closest('.price');
        if (!price) return;

        const container = price.querySelector('.price__container');
        if (!container) return;

        const width = container.offsetWidth;
        el.style.setProperty('--price-width', width + 'px');
      });
    }

    // apply on load
    applyWidth();

    // re-apply on resize
    window.addEventListener('resize', applyWidth);
  }
}
main.jsToggles();
main.megamenu();
main.preventHashLinks();
main.discountTextWidth();

class CounterBlock extends HTMLElement {
  constructor() {
    super();
    this._observer = null;
    this._hasAnimated = false;
  }

  connectedCallback() {
    if (this.hasAttribute('enabled')) {
      // Animate only if `enabled` attribute is present
      this._observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this._hasAnimated) {
            this._hasAnimated = true;
            this.startCounting();
            this._observer.disconnect();
          }
        });
      }, { threshold: 0.6 });

      this._observer.observe(this);
    } else {
      // Just format existing value with commas (no animation)
      const value = parseInt(this.dataset.counter || this.textContent, 10);
      if (!isNaN(value)) {
        this.textContent = value.toLocaleString() + '+';
      }
    }
  }

  startCounting() {
    const target = parseInt(this.dataset.counter, 10);
    const duration = 2000;
    const start = 0;
    const startTime = performance.now();

    const formatNumber = num => num.toLocaleString() + '+';

    const animate = (now) => {
      const progress = Math.min((now - startTime) / duration, 1);
      const value = Math.floor(progress * (target - start) + start);
      this.textContent = formatNumber(value);

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        this.textContent = formatNumber(target);
      }
    };

    requestAnimationFrame(animate);
  }
}

customElements.define('counter-block', CounterBlock);

// js/common/behavior/scroll-progress.js
var ScrollProgress = class extends HTMLElement {
    connectedCallback() {
      this.scrolledElement.addEventListener("scroll", throttle(this._updateScrollProgress.bind(this)));
      if (window.ResizeObserver) {
        new ResizeObserver(this._updateScrollProgress.bind(this)).observe(this.scrolledElement);
      }
    }
    get scrolledElement() {
      return this._scrolledElement = this._scrolledElement || document.getElementById(this.getAttribute("observes"));
    }
    _updateScrollProgress() {
      const scrollLeft = document.dir === "ltr" ? this.scrolledElement.scrollLeft : Math.abs(this.scrolledElement.scrollLeft), advancement = (scrollLeft + this.scrolledElement.clientWidth) / this.scrolledElement.scrollWidth;
      this.style.setProperty("--scroll-progress", Math.max(0, Math.min(advancement, 1)).toFixed(6));
    }
};

if (!window.customElements.get("scroll-progress")) {
  window.customElements.define("scroll-progress", ScrollProgress);
}

class ReadMore extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.classList.remove("hidden");

    const limit = parseInt(this.dataset.limit ?? "185");
    const text = (this.textContent ?? "").trim();

    if (text.length <= limit || text.length - limit < 20) return;

    const fullText = text;
    const truncatedText = text.slice(0, limit).trim() + "...";

    // Clear the element
    this.innerHTML = "";

    // Text container
    const textSpan = document.createElement("span");
    textSpan.textContent = truncatedText + " ";
    this.appendChild(textSpan);

    // Link
    const link = document.createElement("a");
    link.href = "javascript:void(0)";
    link.textContent = this.dataset.moreLabel || "Read more";
    link.classList.add("read-more-desc");
    this.appendChild(link);

    let expanded = false;

    link.addEventListener("click", (e) => {
      e.preventDefault();
      expanded = !expanded;

      if (expanded) {
        textSpan.textContent = fullText + " ";
        link.textContent = this.dataset.lessLabel || "Read less";
        link.style.display = "inline-block"; // show link as block when expanded
      } else {
        textSpan.textContent = truncatedText + " ";
        link.textContent = this.dataset.moreLabel || "Read more";
        link.style.display = ""; // reset display
      }
    });
  }
}

customElements.define("read-more", ReadMore);